<template>
    <v-container class="d-flex justify-center align-center flex-column funds-section">

        <v-card
                :min-width="$vuetify.breakpoint.mdAndUp? '730':''"
                max-width="730"
                elevation="0"
                class="pb-10"
        >

            <v-row class="mt-8 mb-8">
                <v-col class="donation-profile d-flex flex-column flex-md-row align-center">
                    <v-avatar
                            size="120"
                            color="#F4F5F6"
                            class="mr-0 mr-md-8 mb-6 mb-md-0"
                    >
                        <v-img
                                :src="campaign.user.image_url"
                        >
                            <template v-slot:placeholder>
                                <v-icon color="grey lighten-1" size="40">mdi-account-outline</v-icon>
                            </template>
                        </v-img>
                    </v-avatar>
                    <div class="d-flex flex-column">
                        <h3 class="pb-3 text-center text-md-left">
                            Help {{campaign.user.name}} get through college!
                        </h3>
                        <p>
                            Hey there!  {{campaign.user.name}} is headed off to school and sure could use a little help to offset the costs of living. With your help, {{campaign.user.name}} will have a better chance at keeping up on rent and other essential expenses while going to school.
                        </p>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="!campaign.is_active || campaign.is_ended" class="mt-8 mb-8">
                <v-col class="donation-profile d-flex flex-column flex-md-row align-center">
                    <div class="d-flex flex-column">
                        <h3 class="pb-3 text-center">
                            The campaign was ended on {{ campaign.updated_at| formatDate }}
                        </h3>
                    </div>
                </v-col>
            </v-row>
            <DonationSummary :campaign="campaign" v-if="campaign" v-on:getCampaign="getCampaign"></DonationSummary>

        </v-card>

    </v-container>
</template>

<script>
    import moment from "moment";
    import DonationSummary from "../components/DonationSummary";
    import UserService from "../services/user.service";
    export default {
        name: 'Donation',
        components: {DonationSummary},
        data: () => ({
            amount: null,
            isCallingApi: false,
            campaign: null
        }),
        methods: {
           getCampaign: async function() {
               this.isCallingApi = true;
               this.campaign     = await UserService.getCampaignByHash(this.$router.currentRoute.query.cmp, '?appendUser');
               this.isCallingApi = false;
           }
        },
        filters: {
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('LL')
                }
            }
        },
        beforeMount: async function() {
            if (!this.$router.currentRoute.query.cmp) {
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'The campaign you are looking for does not exist. Make sure you are accessing with the correct campaign url',
                    color: 'red'
                });

                this.$router.push('/')
            }

            this.getCampaign();
        }
    }
</script>
<style>

    .donation-profile h3 {
        font-size: 30px !important;
        font-weight: 700;
        line-height: 40px;
    }
    .donation-profile p {
        font-size: 16px !important;
        font-weight: 400;
    }

</style>